import { useState } from "react";

import { useGetListQuery } from "../../features/api/Api";
import { isExists, locale, params, workOrderStatusOptions } from "../../utils";
import { Grid } from "@mui/material";
import {
  MetaTags,
  List,
  MuiDatagrid,
  ListEditButton,
  EnumField,
} from "../../components";
import useLocales from "../../hooks/useLocales";
import { GridColDef } from "@mui/x-data-grid";
import { defaultToolbar } from "../../components/views/datagrid/MuiDatagrid";
import useUser from "../../hooks/useUser";
import { Box, CircularProgress, Typography } from "@mui/material";
import ExpandCellRenderer from "../../components/views/datagrid/ExpandCellRenderer";
import ToolTip from "../../components/tooltip/ToolTip";

const ApplicationList = () => {
  const { user } = useUser();
  const { translate } = useLocales();
  const [workOrderParams, setWorkOrderParams] = useState({
    resource: `fixity/workorder/workorder/customersInBusinessPartnerWorkOrderList`,
    params: {
      ...params,
      filter: {
        isCustomersContactPersonOpenThisWorkOrder: true,
        customerId: user.customerId,
      },
    },
  });

  const { data: workorders, isLoading } = useGetListQuery<any>(workOrderParams);

  const columns: GridColDef[] = [
    {
      field: "workOrderNumber",
      headerName: translate("resources.recommandation.number"),
      flex: 1,
      minWidth: 150,
    },
    /* {
      field: "creationTime",
      headerName: translate("resources.workOrders.creationTime"),
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <CustomDateField data={params.row.creationTime} />
      ),
    }, */

    /* {
      field: "detail.changeEndDate",
      headerName: translate("resources.workOrders.endDate"),
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => {
        return params.row.lastModificationTime ? (
          <CustomDateField data={params.row.lastModificationTime} />
        ) : (
          ""
        );
      },
    }, */
    /* {
      field: "creatorMainGroupName",
      headerName: "Oluşturan Grup",
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => {
        if (!params.row.creatorMainGroupName) {
          return (
            <RefField
              reference={`customer/customer`}
              optionname="alias"
              data={params.row.customerId}
            />
          );
        } else {
          <span>{params.row.organizationGroupName}</span>;
        }
      },
    }, */
    /*  {
      field: "creatorNameSurname",
      headerName: translate("resources.workOrders.creator"),
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => {
        if (!params.row.creatorNameSurname) {
          return (
            <RefField
              reference={`customer/contact`}
              optionname="name"
              data={params.row.creatorId}
            />
          );
        }
      },
    }, */
    {
      field: "customerUsedName",
      headerName: "Müşteri",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "title",
      headerName: "Konu",
      flex: 1,
      minWidth: 150,
      renderCell: ExpandCellRenderer,
    },
    {
      field: "typeName",
      headerName: "İş Emri Tipi",
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => {
        return params.value === "Olay" ? (
          <ToolTip
            style={{ p: 1 }}
            title={
              <Grid container>
                <Grid item sm={12} sx={{ color: "#fff", display: "flex" }}>
                  <Box
                    sx={{ color: "#fff", fontWeight: "bold", marginRight: 1 }}
                  >
                    {translate(
                      "resources.workOrders.slaReactionViolatedStatus"
                    )}
                    :
                  </Box>
                  {params.row.slaReactionViolatedStatus
                    ? translate("resources.workOrders.available")
                    : translate("resources.workOrders.none")}
                </Grid>
                <Grid item sm={12} sx={{ color: "#fff", display: "flex" }}>
                  <Box
                    sx={{ color: "#fff", fontWeight: "bold", marginRight: 1 }}
                  >
                    {translate(
                      "resources.workOrders.slaResolutionViolatedStatus"
                    )}
                    :
                  </Box>
                  {params.row.slaResolutionViolatedStatus
                    ? translate("resources.workOrders.available")
                    : translate("resources.workOrders.none")}
                </Grid>
              </Grid>
            }
          >
            <Box>Olay</Box>
          </ToolTip>
        ) : (
          <Box>{params.value === "Talep" ? "Talep" : "Destek Talebi"}</Box>
        );
      },
    },

    {
      field: "statusId",
      headerName: "İş Emri Durumu",
      flex: 1,
      minWidth: 150,
      renderCell: ({ value }) => (
        <EnumField
          data={value}
          options={locale(workOrderStatusOptions, "resources.recommandation.")}
        />
      ),
    },

    {
      field: translate("actions.edit"),
      headerName: "",
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      hideSortIcons: true,
      sortable: false,
      align: "center",
      width: 50,
      renderCell: (params) => (
        <>
          {Number(user.isReadOnly) === 1 ? null : (
            <ListEditButton data={params} path="general" beforeDelete={true} />
          )}
        </>
      ),
    },
  ];
  return (
    <>
      <MetaTags title={"Başvurular"} />{" "}
      {isLoading ? (
        <Box textAlign="center">
          <CircularProgress />
          <Typography variant="h5">
            Veriler Yükleniyor. Lütfen Bekleyiniz...
          </Typography>
        </Box>
      ) : (
        <List tableName={translate("applications")} loading={isLoading}>
          <MuiDatagrid
            loading={isLoading}
            rows={isExists(workorders?.data) ? workorders?.data : []}
            columns={columns}
            rowCount={workorders?.totalItemCount}
            pageSize={workOrderParams.params.pagination.size}
            pageNumber={workOrderParams.params.pagination.pageNumber}
            setPagination={setWorkOrderParams}
            //filters={<WorkOrderListFilter onSubmit={setWorkOrderParams} />}
            hideToolbars={{
              ...defaultToolbar,
              create: false,
              filter: false,
              export: true,
            }}
            getRowClassName={(params) => {
              if (
                params.row.statusId === workOrderStatusOptions[6].value &&
                params.row.typeName === "Olay"
              ) {
                switch (params.row.slaResolutionViolatedStatus) {
                  case true:
                    return `super-app-theme--resolved_sla_true`;
                    break;
                  default:
                    return `super-app-theme--resolved_sla`;
                    break;
                }
                return "";
              }
              if (params.row.statusId === workOrderStatusOptions[6].value) {
                return `super-app-theme--resolved`;
              }
              if (params.row.statusId === workOrderStatusOptions[1].value) {
                return `super-app-theme--onHold`;
              }

              if (params.row.typeName === "Olay") {
                if (
                  //params.row.slaReactionViolatedStatus === true &&
                  params.row.slaResolutionViolatedStatus === true
                ) {
                  return `super-app-theme--slaReactionViolatedStatus`;
                } /* else if (
                  params.row.slaReactionViolatedStatus === false &&
                  params.row.slaResolutionViolatedStatus === true
                ) {
                  return `super-app-theme--slaResolutionViolatedStatus`;
                } else if (
                  params.row.slaReactionViolatedStatus === true &&
                  params.row.slaResolutionViolatedStatus === true
                ) {
                  return `super-app-theme--slaReactionResolution`;
                } */ else return "";
              } else return "";
            }}
          />
        </List>
      )}
    </>
  );
};

export default ApplicationList;
